import "./BillingInformation.css"
import {Trans, useTranslation} from "react-i18next";
import {Button, Link} from "@mui/material";
import {formatDate} from "../../../utils";
import React, {useState} from "react";
import GenericError from "../../../../Utilities/GenericError";
import PopUp from "../../../../Utilities/PopUp";
import AccountsService from "../../../../../services/AccountsService";
import {useLoading} from "../../../../../context/LoadingContext";
import {useNavigate} from "react-router-dom";
import {useAccount} from "../../../../../context/AccountContext";
import usePaymentProvider from "../../../../../services/PaymentProvider.ts";
import GoogleAnalytics from "../../../../../analytics/GoogleAnalytics";
import BillingContentComponent from "./BillingContentComponent";

const BillingInformationComponent = ({userData, unsubscribed, showBillingInfo, shouldShowCancelButton, isScheduledDowngrade, isPassedDue}) =>{
    const {t} = useTranslation();

    const {isLoading, removeLoading, addLoading} = useLoading();
    let account = useAccount();
    const navigate = useNavigate();
    const paymentProvider = usePaymentProvider();

    const cancelationAnalytics = () => {
        const newProduct = {
            skuName : "Free",
            skuId : "Free",
            prodAttribute: "00000",
            price: 0
        };
        let analyticsObject = account.setupAnalyticsEvProductConvertion(newProduct);
        GoogleAnalytics.onEvProductConversion(analyticsObject);
    }
    const onUnsubscribeHandle = () => {
        account.clearSessionCoupon();
        if(!(isLoading("UNSUBSCRIBING"))){
            addLoading("UNSUBSCRIBING")
        }
        paymentProvider.OnUnsubscribeHandle(navigate, userData.subscription, cancelationAnalytics)
            .finally(()=>{
                removeLoading("UNSUBSCRIBING")
            })
    };

    return (<>
        {unsubscribed.hasUnsubscribed ?
            <>
                <div className={"subscriptionInformation-hasUnsubscribed"}>
                    <img src={"images/account/unsubscribeIcon.svg"} alt={"unsubscribe icon"}/>
                    {unsubscribed.isCanceled ?
                        <span>
                            {t("accountProductScheduledDowngradeFinal")}
                        </span>
                        :
                        unsubscribed.isFinalBill ?
                            <span className={"pick-program-fallback-modal"}>
                                <Trans i18nKey="reactivationOfDowngradedSubscription"
                                       tOptions={{interpolation: {escapeValue: false}}}
                                       components={{Link: <Link className="clickable"
                                                                href={"https://help.antennaplus.gr/contact-us/"}
                                                                target={"_blank"}/>}}
                                />
                            </span>
                            :
                            <span>
                                <CancelCancelationComponent current_period_ends_at={userData?.subscription?.current_period_ends_at} />
                            </span>
                    }
                </div>
            </> :
            showBillingInfo ?
                <>
                    {!unsubscribed.isCanceled ?
                        <div className={"subscriptionInformation-hasActiveSubscription"}>
                            <div className={"subscriptionInformation-billing"}>
                                <BillingContentComponent label={t("accountProductNextBillingAmount")} type={"amount"}>
                                    <>
                                        {(userData?.subscription?.state === "past_due" ?
                                            userData?.renewalPreview?.existing_balance_in_cents
                                            :
                                            userData?.renewalPreview?.total_amount_due_in_cents) / 100}€
                                    </>
                                </BillingContentComponent>
                                <BillingContentComponent type={"date"} label={t("accountProductNextBillingDate")}>
                                    <>
                                        {formatDate(userData?.subscription?.state === "past_due" ?
                                            userData?.subscription?.next_assessment_at
                                            :
                                            userData?.renewalPreview?.next_assessment_at)}
                                    </>
                                </BillingContentComponent>
                            </div>
                        </div>:<></>
                    }
                    {isPassedDue ?
                        <div className={"subscriptionInformation-hasUnsubscribed"}>
                            <img src={"images/account/unsubscribeIcon.svg"} alt={"Attention icon"}/>
                            <span>
                                <Trans i18nKey="accountBillingFailed"
                                       values={{date: formatDate(userData?.subscription?.next_assessment_at)}}
                                       tOptions={{interpolation: {escapeValue: false}}}
                                />
                            </span>
                        </div>
                        :
                        <>
                            {isScheduledDowngrade ?
                                <div
                                    className={"subscriptionInformation-hasUnsubscribed"}>
                                    <img src={"images/account/unsubscribeIcon.svg"}
                                         alt={"unsubscribe icon"}/>
                                    <span>
                                        <Trans i18nKey="accountScheduledDowngrade"
                                               values={{
                                                   date: formatDate(userData?.subscription?.current_period_ends_at),
                                                   before: userData?.subscription?.product?.displayName,
                                                   after: userData?.subscription?.next_product_name ?? userData?.subscription?.product?.displayName,
                                               }}
                                               tOptions={{interpolation: {escapeValue: false}}}
                                        />
                                    </span>
                                </div>
                                :
                                <></>
                            }
                        </>
                    }
                </>
                :
                <></>
        }
        {shouldShowCancelButton ?
            <button className={"subscriptionInformation-cancel-cta"}
                    onClick={onUnsubscribeHandle}>{t("accountCancelSubscriptionCTA")}</button> : <></>
        }
    </>)
}

const CancelCancelationComponent = ({current_period_ends_at}) => {
    const navigate = useNavigate();
    const {t} = useTranslation();

    const [cancelationPopup, setCancelationPopup] = useState(false);

    const confirmCancelation = () => {
        setCancelationPopup(true);
    }
    const [genericError, setGenericError] = useState(false);
    const [errorMessage, setErrorMessage] = useState(null);
    const [loadingState, setLoadingState] = useState(false);
    const handleCancelCancellation = () =>{
        setLoadingState(true)
        AccountsService.restartSubscription().then((response) =>{
            navigate(0)
        }).catch((error)=>{
            let errorCodeKey = error?.response?.data?.code;
            setErrorMessage(errorCodeKey);

            setGenericError(true);
            setCancelationPopup(false);
            setLoadingState(false);
        })
    }
    return (<>
        <Trans i18nKey="accountProductScheduledDowngradePending"
               values={{date: formatDate(current_period_ends_at)}}
               tOptions={{interpolation: {escapeValue: false}}}
               components={{Span: <button onClick={confirmCancelation}/>}}
        />
        <PopUp
            openPopUp={cancelationPopup}
            setOpenPopUp={()=>{}}
            showCloseButton={true}
            outlined={false}
            maxWidth="sm"
            error={false}
            closeWhenClickedOutside={false}
            isLoading={loadingState}
        >
            <GenericError
                setClose={()=>{}}
                success={true}
                mainText={t("reactivateSubscriptionText")}
                hideButtons={true}
                showIcon={false}>
                <Button variant="contained" color="primary" onClick={()=>{handleCancelCancellation()}}>
                    {t("reactivateSubscriptionButtonText")}
                </Button>
            </GenericError>
        </PopUp>
        <PopUp
            openPopUp={genericError}
            setOpenPopUp={setGenericError}
            maxWidth="md"
            showCloseButton={false}
            outlined={false}
            error={true}
            closeWhenClickedOutside={false}>
            <GenericError
                setClose={setGenericError}
                mainText={t("billingInformationGenericErrorTitle."+errorMessage, { defaultValue: t("billingInformationGenericErrorTitle") })}
                showIcon={false}>
            <span className={"pick-program-fallback-modal"}>
                {t("billingInformationErrorMessage."+errorMessage, {defaultValue: t("billingInformationErrorMessage")})}
            </span>
            </GenericError>
        </PopUp>
    </>)
}
export default BillingInformationComponent;